var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{attrs:{"id":"overlay-background","variant":"'transparent'","show":_vm.loading,"opacity":"1","rounded":"sm"},scopedSlots:_vm._u([{key:"overlay",fn:function(){return [_c('div',{staticClass:"text-center"},[_c('img',{attrs:{"alt":"Servislet","src":require("@/assets/servislet.gif")}})])]},proxy:true}])},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }